import React from 'react';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { MobileStickyBar } from '../components/layout/MobileStickyBar';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/home/Hero';
import { TrustRail } from '../components/home/TrustRail';
import { DecisionCards } from '../components/home/DecisionCards';
import { PopularPaths } from '../components/home/PopularPaths';
import { GuidedBuyer } from '../components/home/GuidedBuyer';
import { CommercialStrip } from '../components/home/CommercialStrip';
import { InstallationService } from '../components/home/InstallationService';
import { Checklist } from '../components/home/Checklist';
import { ReviewsTrust } from '../components/home/ReviewsTrust';
import { usePageTitle } from '../hooks/usePageTitle';
export function Home() {
  usePageTitle('MidAtlantic Mailboxes | Mailboxes, Commercial Delivery & Outdoor Accents');
  return <div className="min-h-screen flex flex-col" data-id="element-830" data-mp="30w9nf4asqr08">
      <TopBar data-id="element-831" data-mp="2vx6qk74yzr3c" />
      <Header data-id="element-832" data-mp="2vxf4m2ctx2g4" />
      <Navigation data-id="element-833" data-mp="2vyzxlnjhwdbv" />

      <main className="flex-grow" data-id="element-834" data-mp="2vyhrlz716kqr">
        <Hero data-id="element-835" data-mp="2qybx8b9dmk4z" />
        <TrustRail data-id="element-836" data-mp="2qxu4vppu4q2c" />
        <DecisionCards data-id="element-837" data-mp="2qxal03gmjrlo" />
        <PopularPaths data-id="element-838" data-mp="2qwsjosf3un6w" />
        <GuidedBuyer data-id="element-839" data-mp="2mx0i4zo4phb1" />
        <CommercialStrip data-id="element-840" data-mp="2mxjork8bwj9r" />
        <InstallationService data-id="element-841" data-mp="2mw8ldlispdj6" />
        <Checklist data-id="element-842" data-mp="2mz3498m5uqah" />
        <ReviewsTrust data-id="element-843" data-mp="2hxxd3f85fb32" />
      </main>

      <Footer data-id="element-844" data-mp="2hyyvy5vep1vc" />
      <MobileStickyBar data-id="element-845" data-mp="2hzi3qtrce9vn" />
    </div>;
}